import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7ac5a4ac&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7ac5a4ac&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac5a4ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ac5a4ac')) {
      api.createRecord('7ac5a4ac', component.options)
    } else {
      api.reload('7ac5a4ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7ac5a4ac&scoped=true&", function () {
      api.rerender('7ac5a4ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/distribution/index.vue"
export default component.exports